export const TU_BOLSILLO = "TUBOLSILLO";
export const PAYPAL = "PAYPAL";
export const BRAINTREE = "BRAINTREE";
export const BAMBORA = "BAMBORA";
export const VISA = "VISA";
export const MASTERCARD = "MASTERCARD";
export const DISCOVERY = "DISCOVERY";
export const CASH = "CASH";
